var _path, _path2, _path3, _path4, _path5, _path6, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVotingPowerFormula(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 245.753,
    height: 55.54,
    viewBox: "0 0 245.753 55.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_70009",
    "data-name": "Group 70009",
    transform: "translate(-596.932 730.258)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V_P_M",
    "data-name": "V P M",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70008",
    "data-name": "Group 70008",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_42841",
    "data-name": "Path 42841",
    d: "M601.976-680.6l-5.044-40.469h5.1l2.943,25.939c.48,4.143.72,6.485.78,9.127h.18a100.929,100.929,0,0,1,4.444-9.787l12.848-25.279h5.525L607.439-680.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42842",
    "data-name": "Path 42842",
    d: "M638.6-700.9v-3.543h30.021v3.543Zm0,11.828v-3.542h30.021v3.542Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42843",
    "data-name": "Path 42843",
    d: "M708.91-674.718h-3.662L700.505-700.6l-4.5,1.8-.721-2.7,8.527-3.482,3.422,21.015a27.737,27.737,0,0,1,.42,3.783h.121c.36-1.021.9-2.582,1.38-3.9l18.314-46.173h3.783Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42844",
    "data-name": "Path 42844",
    d: "M745.717-720.471a40.134,40.134,0,0,1,8.765-.9c3.9,0,7.626.961,9.908,3.122a9.447,9.447,0,0,1,2.942,7.326,13.933,13.933,0,0,1-4.863,10.567c-3.123,2.642-7.686,3.843-12.249,3.843a29.222,29.222,0,0,1-4.144-.3L743.015-680.6h-4.924Zm1.14,19.454a18.33,18.33,0,0,0,4.023.42c6.845,0,11.408-4.263,11.408-9.967,0-4.8-3.422-6.725-8.046-6.725a18.362,18.362,0,0,0-4.383.42Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42845",
    "data-name": "Path 42845",
    d: "M780.42-698.736a2.745,2.745,0,0,1,2.762-2.882,2.334,2.334,0,0,1,2.4,2.522,2.711,2.711,0,0,1-2.821,2.822A2.337,2.337,0,0,1,780.42-698.736Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42846",
    "data-name": "Path 42846",
    d: "M832.718-680.6l2.882-21.855c.54-3.843,1.441-9.788,2.221-13.69h-.24c-1.861,4.083-4.083,8.886-6.3,13.029l-12.008,22.276h-3.843l-3-21.8c-.6-4.683-1.021-9.366-1.261-13.509h-.12c-.9,3.723-2.162,9.847-3.122,13.69L802.4-680.6h-4.684l10.508-40.469h6.364l3.183,23.237c.42,3.422.9,7.085.961,10.087h.179c1.261-3,3-6.605,4.744-9.967L836.2-721.072h6.485L837.521-680.6Z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11179",
    "data-name": "Rectangle 11179",
    width: 115.183,
    height: 3.495,
    transform: "translate(727.502 -730.258)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVotingPowerFormula);
export default __webpack_public_path__ + "static/media/voting-power-formula.402c28a25dd2c16328b18e3c4f0b7422.svg";
export { ForwardRef as ReactComponent };